import { Head } from '@inertiajs/react';

interface Props {
  viewportContent?: string;
  pageTitle?: string;
}

export function MetaTags({
  viewportContent = 'width=device-width, initial-scale=1.0, user-scalable=no',
  pageTitle = 'with',
}: Props) {
  return (
    <Head>
      <title head-key="title">{pageTitle}</title>
      {/* デフォルトのviewportでレンダリングしたのちにRails側のviewportを上書きすることで、レイアウトシフトを防ぐ */}
      <meta head-key="viewport" name="viewport" content={viewportContent} />
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="google-site-verification" content="Wi3K2YWsNTgC6BueDv445QrdimpIcvxOUSFreX36we8" />

      {/* Apple Touch Icons */}
      {/* http://realfavicongenerator.net/favicon?file_id=p19v55hvav9cm1a3q1j1chj58m96# */}
      <link rel="apple-touch-icon" sizes="57x57" href="/apple-touch-icon-57x57.png" />
      <link rel="apple-touch-icon" sizes="60x60" href="/apple-touch-icon-60x60.png" />
      <link rel="apple-touch-icon" sizes="72x72" href="/apple-touch-icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="76x76" href="/apple-touch-icon-76x76.png" />
      <link rel="apple-touch-icon" sizes="114x114" href="/apple-touch-icon-114x114.png" />
      <link rel="apple-touch-icon" sizes="120x120" href="/apple-touch-icon-120x120.png" />
      <link rel="apple-touch-icon" sizes="144x144" href="/apple-touch-icon-144x144.png" />
      <link rel="apple-touch-icon" sizes="152x152" href="/apple-touch-icon-152x152.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon-180x180.png" />

      {/* Favicons */}
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="192x192" href="/android-chrome-192x192.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />

      {/* Manifest and Theme */}
      <link rel="manifest" href="/manifest.json" />
      <meta name="msapplication-TileColor" content="#fe6970" />
      <meta name="msapplication-TileImage" content="/mstile-144x144.png" />
      <meta name="theme-color" content="#ffffff" />
    </Head>
  );
}
